import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../../config';
import common from './../../common';
import {
    getFixtures,
} from './../../actions/ManageTeamActions';
import {
    triggerMixFetchData,
    triggerLiveScoreFetchData,
} from './../../actions/FormationActions';
import {
    getFixturesToPrintForMatches,
    getFixtureStatus,
    getLiveScoreLine,
} from "../../helper";
import {
    getMatchTimeObj,
} from "../../helper-common";
import OutsideNotifier from '../../OutsideNotifier';
import TopSectionHeader from './../manage-team/Top-Section-Header';
import MatchdayStatus from './../manage-team/Matchday-Status';
import { getStep } from './../../route-component';
import AdBottom from '../AdBottom';
import { findIndex, isEmpty } from 'lodash';
import MatchDetails from './Match-Details';
import PlayerCard from './../playerCard';

class Matches extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timeout: null,
            displayFixtures: {},
            teamlock: null,
            activeMatchId: 0
        }
    }

    timeout_mix = 0;
    timeout_local = 0;
    timeout_live = 0;
    setInitialState = () => {
        this.setState({
            responseData: {},
            userSpecificFixtures: [],
            isDDOpen: false,
            currentActiveFixture: 0,
        });
    };

    componentWillMount() {
        this.setInitialState();
    }

    componentDidMount() {
        this.props.getFixtures().then(() => {
            this.init();
        });
    }

    componentWillUnmount() {
        this.clearAllTimeout();
    }

    startInterval = (Deadline, OffSet, MixApiFixtureStatus) => {
        if (MixApiFixtureStatus !== config.fixtureStatus.isLock) {
            common.getDiffWithCurrentTimeInMinutes(Deadline, OffSet, (diffInMins) => {
                if (diffInMins > config.TIME_DIFF_TO_CONSIDER) {
                    if (diffInMins < config.MIXED_API_INTERVAL_START_TIME) {
                        this.timeout_mix = setTimeout(this.hitMixAPi, 1000 * config.MIXED_API_INTERVAL_DURATION);
                    } else {
                        this.timeout_local = setTimeout(() => {
                            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
                        }, 1000 * config.MIXED_API_BEFORE_INTERVAL_DURATION);
                    }
                }
            });
        }
    };
    hitMixAPi = () => {
        this.props.triggerMixFetchData().then(() => {
            const mixedResponse = this.props.mixResponse;
            const { OffSet } = this.props.constraints;
            let { Deadline, Fixture } = mixedResponse;
            const MixApiFixtureStatus = getFixtureStatus(Fixture || {});
            if (Fixture !== null) {
                const { userSpecificFixtures, currentActiveFixture } = this.state;
                const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
                const gamedayId = currentFixture['GDID'];
                if (+gamedayId === +Fixture['GDID']) {
                    const userFixtureStatus = currentFixture.status;
                    if (userFixtureStatus !== MixApiFixtureStatus) {
                        common.updateBusters('/bust-after-status-change');
                        return this.init();
                    }
                }
            }
            this.startInterval(Deadline, OffSet, MixApiFixtureStatus);
        });
    };
    callLiveAPI = () => {
        this.props.triggerLiveScoreFetchData().then(() => {
            this.timeout_live = setTimeout(() => {
                this.hitMixAPi();
                this.callLiveAPI();
            }, 1000 * config.MIXED_API_INTERVAL_DURATION);
        });
    };
    clearAllTimeout = () => {
        clearTimeout(this.timeout_mix);
        clearTimeout(this.timeout_local);
        clearTimeout(this.timeout_live);
    };
    checkForLiveScoring = (selectedGameDay) => {
        this.clearAllTimeout();
        if (selectedGameDay.status === config.fixtureStatus.isLock) {
            this.callLiveAPI();
        } else if (selectedGameDay.status !== config.fixtureStatus.isFinished) {
            this.hitMixAPi();
        }
    };
    init = () => {
        const { fixtures } = this.props;
        const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
        const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
        const selectedGameDay = userSpecificFixtures[defaultIndex];
        this.checkForLiveScoring(selectedGameDay);
        const groupByMatches = this.createFixtureGroups(selectedGameDay);
        this.setState({
            userSpecificFixtures,
            displayFixtures: groupByMatches.group,
            teamlock: groupByMatches.lockTime,
            currentActiveFixture: defaultIndex,
        });
    };
    createFixtureGroups = (gameday) => {
        const { trans, constraints } = this.props;
        let obj = {
            group: {},
            lockTime: ''
        };
        for (let i = 0; i < gameday.Match.length; i++) {
            let match = gameday.Match[i];
            let MDNo = match.MDNo;
            if (!obj.group[MDNo]) {
                // match.DateTime = '2018-08-08 20:45';
                obj.group[MDNo] = {
                    date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
                    subsWindow: {
                        isAvailable: false
                    },
                    matches: []
                };
                if (match.TeamSc) {
                    obj.group[MDNo]["subsWindow"]["isAvailable"] = (match.TeamSc === "UT_SUB");
                    obj.group[MDNo]["subsWindow"]["TeamScStartDate"] = match.TeamScStartDate;
                    obj.group[MDNo]["subsWindow"]["TeamScEndDate"] = match.TeamScEndDate;
                    if (match.TeamSc === "UT_TRF") {
                        obj.lockTime = match.TeamScEndDate;
                    }
                }
            }
            obj.group[MDNo].matches.push(match);
        }
        return obj;
    };
    getSubsWindow = (obj) => {
        const { trans, constraints } = this.props;
        const TeamScStartDate = getMatchTimeObj(obj.TeamScStartDate, trans, constraints.OffSet);
        const TeamScEndDate = getMatchTimeObj(obj.TeamScEndDate, trans, constraints.OffSet);
        return <div className="si-fixture-wrap-sub">
            <div className="si-fixture-wrap-sub-fItem">
                <div className="si-fixture-subReset">
                    <i className="icon-ucl-subsitute" />
                </div>
            </div>
            <div className="si-fixture-wrap-sub-fItem">
                <div className="si-fixture-sub-title">
                    <span>{ trans.subsWindow }</span>
                </div>
                <div className="si-fixture-sub-title2">
                    <span>{ TeamScStartDate.dateDay }, { TeamScStartDate.matchTime }
                        – { TeamScEndDate.dateDay }, { TeamScEndDate.matchTime } </span>
                </div>
            </div>
            <div className="si-fixture-wrap-sub-fItem">
                <div className="si-fixture-subInfo">
                    <i className="icon-ucl-more_nfo" />
                    <div className="si-fixture-toolTip">
                        <span>{ trans.subsWindowTooltip }</span>
                    </div>
                </div>
            </div>
        </div>
    };
    onMatchClick = (e, matchId, MStatus) => {
        e.stopPropagation();

        if (+MStatus === config.enumMatchStatus.isLock) {
            //update buster
            common.updateBusters('/matchdetails');
        }

        if (matchId == this.state.activeMatchId) {
            this.setState({ activeMatchId: 0 })
        } else {
            this.setState({ activeMatchId: 0 }, () => {
                this.setState({ activeMatchId: matchId })
                document.getElementById(matchId).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

            })
        }

        // return this.props.history.push('/matchdetails/' + matchId + "/" + MStatus);
    };
    onDDTap = () => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: --currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.state;
        this.setState({ currentActiveFixture: ++currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (currentActiveFixture) => {
        this.setState({ currentActiveFixture, isDDOpen: !this.state.isDDOpen, });
        this.pageNumber = 1;
        this.getRespectiveData(currentActiveFixture);
    };
    getRespectiveData = (currentActiveFixture) => {
        const { userSpecificFixtures } = this.state;
        const selectedGameDay = userSpecificFixtures[currentActiveFixture];
        this.checkForLiveScoring(selectedGameDay);
        const groupByMatches = this.createFixtureGroups(selectedGameDay);
        this.setState({ displayFixtures: groupByMatches.group, teamlock: groupByMatches.lockTime });
    };
    returnScore = (score) => {
        let type = typeof score;
        return (type === 'number' || type === 'string') ? score : '';
    };

    render() {
        const location = this.props.location;
        const pathStep = (location ? getStep(location.pathname) : "");
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-manage-team': true,
            'si-no-anim': true,
            'si-matches': true
        });
        const { displayFixtures, teamlock, userSpecificFixtures, currentActiveFixture } = this.state;
        const { constraints, trans } = this.props;
        let isFixtureUpdated = (+constraints['IsFixtureUpdated'] === 1);
        if (userSpecificFixtures.length === 0) return null;
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        const selectedLabel = trans['rd' + selectedMatchDay.GDID];
        const isFirst = currentActiveFixture === 0;
        const isLast = currentActiveFixture === (userSpecificFixtures.length - 1);
        const prevBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_right': true,
            'si-disabled': isFirst
        });
        const nextBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_left': true,
            'si-disabled': isLast
        });
        return <div className={ wrapperClass }>
            <div className="si-container">
                <div className="si-top-section">
                    {/* <TopSectionHeader pathStep={pathStep} /> */ }
                    { isFixtureUpdated ? <div className="si-selectbox">
                        <div className="si-dropdown-btn">
                            <i className={ prevBtnClasses } onClick={ () => this.onPreviousTap() } />
                            <span onClick={ () => this.onDDTap() }>{ selectedLabel }</span>
                            <i className={ nextBtnClasses } onClick={ () => this.onNextTap() } />
                        </div>
                        { this.state.isDDOpen ? <OutsideNotifier handler={ () => this.onDDTap() }>
                            <ul className="si-dropdown-options">
                                { userSpecificFixtures.map((el, index) => {
                                    const selectedLabel = trans['rd' + el.GDID];
                                    const isSelected = currentActiveFixture === index ? 'si-selected' : '';
                                    return <li key={ index } className={ isSelected }
                                        onClick={ () => this.onSelect(index) }>
                                        <span>{ selectedLabel }</span></li>
                                }) }
                            </ul>
                        </OutsideNotifier> : null }
                    </div> : null }
                    { isFixtureUpdated ? <MatchdayStatus pathStep={ pathStep } deadline={ teamlock } /> : null }
                </div>
                {
                    isFixtureUpdated ?
                        <div className="si-fixture-wrap">
                            {
                                Object.keys(displayFixtures).map((key, index) => {
                                    let day = displayFixtures[key].date.dateDay;
                                    let boxMatches = displayFixtures[key].matches;
                                    let isSubsWindow = displayFixtures[key].subsWindow.isAvailable;
                                    let subsWindow = isSubsWindow ? this.getSubsWindow(displayFixtures[key].subsWindow) : null;
                                    return <div key={ index }>
                                        { subsWindow }
                                        <div className="si-fixture-box">
                                            <div className="si-fixture-head">
                                                <span>{ day }</span>
                                            </div>
                                            <ul className="si-teamList-wrap">
                                                {
                                                    boxMatches.map(match => {
                                                        let matchId = match.MID;
                                                        let HTImg = config.UEFAImgBase + `teams/logos/140x140/${match['HTID']}.png`;
                                                        let ATImg = config.UEFAImgBase + `teams/logos/140x140/${match['ATID']}.png`;
                                                        let MStatus = +match['MatchStatus'];
                                                        const { liveScore } = this.props;
                                                        const ScoreLine = getLiveScoreLine(matchId, liveScore);
                                                        const isScorelineEmpty = isEmpty(ScoreLine);
                                                        let isLiveAPILoaded = false;
                                                        if (!isScorelineEmpty) {
                                                            MStatus = config.liveAndFixtureStatusMap[ScoreLine.Status];
                                                            isLiveAPILoaded = true;
                                                        }
                                                        let matchClickHandler = {
                                                            onClick: () => {
                                                            }
                                                        };
                                                        let matchClassesObj = {
                                                            'si-teamList-teamInfo-fBox': true
                                                        };
                                                        let teamListStatus = null;
                                                        let arrow = null
                                                        if (MStatus === config.enumMatchStatus.isFinished) { //post
                                                            matchClassesObj['si-matCompleted'] = true;
                                                            arrow = (<div className="si-team__arrow"></div>)
                                                            if (!isScorelineEmpty) {
                                                                const HTScr = this.returnScore(ScoreLine[match['HTID']]);
                                                                const ATScr = this.returnScore(ScoreLine[match['ATID']]);
                                                                teamListStatus = HTScr + ' - ' + ATScr;
                                                            } else {
                                                                teamListStatus = this.returnScore(match.HTScr) + ' - ' + this.returnScore(match.ATScr);
                                                            }
                                                            matchClickHandler = { onClick: (e) => this.onMatchClick(e, matchId, MStatus) };
                                                        } else if (MStatus === config.enumMatchStatus.isLock) { //live
                                                            arrow = (<div className="si-team__arrow"></div>)
                                                            const HTScr = this.returnScore(ScoreLine[match['HTID']]);
                                                            const ATScr = this.returnScore(ScoreLine[match['ATID']]);
                                                            matchClassesObj['si-matLiv'] = isLiveAPILoaded;
                                                            teamListStatus = HTScr + ' - ' + ATScr;
                                                            matchClickHandler = { onClick: (e) => this.onMatchClick(e, matchId, MStatus) };
                                                        } else if (MStatus === config.enumMatchStatus.isUpComing) { //pre
                                                            let matchDate = getMatchTimeObj(match.DateTime, trans, constraints.OffSet);
                                                            matchClassesObj['si-matUpcoming'] = true;
                                                            teamListStatus = matchDate.matchTime;
                                                            // teamListStatus = trans.postponed ? trans.postponed : "Postponed"
                                                        }
                                                        let matchClasses = common.makeClasses(matchClassesObj);
                                                        return <li id={ matchId } key={ matchId }
                                                            data-matchid={ matchId } className={ (this.state.activeMatchId == matchId ? "si-active" : "") }>
                                                            <div className={ matchClasses } { ...matchClickHandler }>
                                                                { arrow }
                                                                <div className="si-teamList-teamInfo-fItem si-teamInfo-teamA">
                                                                    <div className="si-teamInfo-fBox">
                                                                        <div className="si-teamInfo-plyName">
                                                                            <div className="si-fullName">
                                                                                <span>{ match['HTName'] }</span>
                                                                            </div>
                                                                            <div className="si-shortName">
                                                                                <span>{ match['HTSName'] }</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="si-teamInfo-plyThumb"
                                                                            style={ { backgroundImage: "url(" + HTImg + ")" } } />
                                                                    </div>
                                                                </div>
                                                                <div className="si-teamList-teamInfo-fItem si-teamInfo-vs">
                                                                    <div className="si-teamList-status">
                                                                        <span>{ teamListStatus }</span>
                                                                    </div>
                                                                </div>
                                                                <div className="si-teamList-teamInfo-fItem si-teamInfo-teamB">
                                                                    <div
                                                                        className="si-teamInfo-fBox si-flexBox-reverse">
                                                                        <div className="si-teamInfo-plyName">
                                                                            <div className="si-fullName">
                                                                                <span>{ match['ATName'] }</span>
                                                                            </div>
                                                                            <div className="si-shortName">
                                                                                <span>{ match['ATSName'] }</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="si-teamInfo-plyThumb"
                                                                            style={ { backgroundImage: "url(" + ATImg + ")" } } />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                (matchId == this.state.activeMatchId)
                                                                    ?
                                                                    <MatchDetails matchId={ matchId } currGameday={ selectedMatchDay.GDID } MStatus={ MStatus } />

                                                                    :
                                                                    null
                                                            }
                                                        </li>
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                })
                            }
                        </div> :
                        <div className="si-no-fixture-wrap">
                            <i className="icon-ucl-warning-icon" />
                            <div className="si-txt">{ trans.noFixture }</div>
                        </div>
                }
                { this.props.isPlayerCardVisible && this.props.overview ? <PlayerCard GDIDFromFetch={ this.props.constraints.leaderboardGamedayId } /> : null }
                <AdBottom />
            </div>
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFixtures: (GamedayId) => dispatch(getFixtures(GamedayId)),
        triggerMixFetchData: () => dispatch(triggerMixFetchData()),
        triggerLiveScoreFetchData: () => dispatch(triggerLiveScoreFetchData()),
    };
};
const mapStateToProps = (state) => {
    return {
        constraints: state.appData.constraints,
        trans: state.appData.trans,
        fixtures: state.formationData.fixtures,
        mixResponse: state.formationData.mixResponse,
        liveScore: state.formationData.liveScore.response,
        isMatchDetailsLoading: state.formationData.isMatchDetailsLoading,
        isPlayerCardVisible: state.formationData.isPlayerCardVisible,
        overview: state.formationData.overview,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(Matches));


// WEBPACK FOOTER //
// ./src/components/matches/index.js